import { Navigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import BenefitsSection from "@/components/BenefitsSection";
import JourneyPath from "@/components/JourneyPath";
import FAQSection from "@/components/FAQSection";
import ContactForm from "@/components/ContactForm";
import USPSection from "@/components/USPSection";
import Footer from "@/components/Footer";
import PageTransition from "@/components/PageTransition";
import SEOHead from "@/components/SEOHead";
import { organizationSchema, localBusinessSchema, homepageFaqSchema, websiteSchema } from "@/lib/seo-schemas";
import { useBusinessMode, businessModeContent } from "@/hooks/use-business-mode";

const Index = () => {
  const { mode } = useBusinessMode();
  const content = businessModeContent[mode];

  // In Digital & IT mode, the homepage lives at /digital-it — redirect there.
  if (mode === "digital") return <Navigate to="/digital-it" replace />;


  return (
    <PageTransition>
      <SEOHead
        title={content.seoTitle}
        description={content.seoDescription}
        canonical="/"
        keywords="ManageMatch, Manage Match, Dienstleistungen Hanau, Hausmeisterservice Hanau, Reinigungsservice Rhein-Main, Facility Management, Gebäudemanagement, Winterdienst, Gartenarbeiten, Elektroservice, Website Erstellung, IT Helpdesk"
        jsonLd={[websiteSchema, organizationSchema, localBusinessSchema, homepageFaqSchema]}
      />
      <div className="public-compact min-h-screen overflow-x-clip">
        <Navbar />
        <JourneyPath />
        <main>
          <HeroSection />
          <USPSection />
          <ServicesSection />
          <BenefitsSection />
          <FAQSection />
          <ContactForm />
        </main>
        <Footer />
      </div>
    </PageTransition>
  );
};

export default Index;
